import { Component, OnInit } from '@angular/core';
import { DialogComponent, DialogService } from 'ng2-bootstrap-modal';
import { buildCloudLoginUrl, CloudRegion } from '../transition-urls';

export interface LoginNoticeModalModel {
  title: string;
  data: any;
}

@Component({
  selector: 'app-login-notice-modal',
  templateUrl: './login-notice-modal.component.html',
  styleUrls: ['./login-notice-modal.component.css']
})
export class LoginNoticeModalComponent extends DialogComponent<LoginNoticeModalModel, string> implements OnInit {
  title: string;
  data: any;
  /** Email used during the real backend sign in; appended to the cloud login URL. */
  email: string;

  constructor(dialogService: DialogService) {
    super(dialogService);
  }

  ngOnInit() {
    this.email = this.data && this.data.email ? this.data.email : '';
    setTimeout(function () {
      document.getElementsByTagName('body')[0].classList.add('modal-open');
    }, 310);
  }

  /** Continue to OpenLM Cloud for the chosen region, carrying the signed-in email. */
  loginRegion(region: CloudRegion) {
    window.open(buildCloudLoginUrl(region, this.email), '_blank');
  }

  /** "Don't have an account?" — signal the opener to show the sign-up notice. */
  signUp() {
    this.result = 'OPEN_SIGNUP';
    this.close();
  }
}



// WEBPACK FOOTER //
// C:/Work/Projects/OnlineParser/web2-ui/src/app/custom-modals/login-notice-modal.component.ts